[
  {
    "code": "KP-04",
    "name": "Chagang-do"
  },
  {
    "code": "KP-09",
    "name": "Hamgyong-bukto"
  },
  {
    "code": "KP-08",
    "name": "Hamgyong-namdo"
  },
  {
    "code": "KP-06",
    "name": "Hwanghae-bukto"
  },
  {
    "code": "KP-05",
    "name": "Hwanghae-namdo"
  },
  {
    "code": "KP-07",
    "name": "Kangwon-do"
  },
  {
    "code": "KP-13",
    "name": "Najin Sonbong-si"
  },
  {
    "code": "KP-03",
    "name": "P’yongan-bukto"
  },
  {
    "code": "KP-02",
    "name": "P’yongan-namdo"
  },
  {
    "code": "KP-01",
    "name": "P’yongyang-t’ukpyolsi"
  },
  {
    "code": "KP-10",
    "name": "Yanggang-do"
  }
]